import './RemindPasswordPage.css';

import { NavLink, Redirect } from 'react-router-dom';
import { closeSavePasswordNotification, forgotPassword } from '../../stores/actions/accountActions';
import { emptyHeaderStyle, loaderStyle } from '../../helpers/CustomStyles';

import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooterTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import Email from '@material-ui/icons/Email';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Loading from '../../components/Loading/Loading';
import Logo from '../../assets/img/WISENE_logo_medium.png';
import React from 'react';
import Snackbar from '../../../components/Snackbar/Snackbar';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import remindPasswordPageStyle from '../../assets/jss/views/loginPageStyleTS';
import utils from '../../helpers/GlobalVariables';

interface IRemindPasswordPageProps {
	cardAnimation: string;
	resettingPasswordSucceed: boolean;
	resettingPasswordFailed: boolean;
	resetPasswordTimeoutFailed: boolean;
	classes: ClassNameMap;
	forgotPassword: (email: string) => void;
	closeSavePasswordNotification: () => void;
}

interface IRemindPasswordPageState {
	sendButtonDisabled: boolean;
	goToLoginPage: boolean;
	remindPasswordEmailValue: string;
	remindPasswordEmailError: boolean;
	remindPasswordEmailFocusOut: boolean;
	mobileViewLocal: boolean;
	isLoaderRender: boolean;
}

class RemindPasswordPage extends React.Component<IRemindPasswordPageProps, IRemindPasswordPageState> {
	state = {
		sendButtonDisabled: false,
		goToLoginPage: false,
		remindPasswordEmailValue: '',
		remindPasswordEmailError: false,
		remindPasswordEmailFocusOut: false,
		mobileViewLocal: false,
		isLoaderRender: false,
	};

	closeSavePasswordNotificationTimeout: ReturnType<typeof setTimeout> = null;
	sendButtonTimer: ReturnType<typeof setTimeout> = null;
	redirectTimer: ReturnType<typeof setTimeout> = null;
	remindPasswordEmailRef = React.createRef<HTMLDivElement>();
	closeNotificationTimer: ReturnType<typeof setTimeout> = null;
	formRef = React.createRef<HTMLFormElement>();

	onKeyDown = (event: KeyboardEvent): void => {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter' && this.state.remindPasswordEmailValue && !this.state.sendButtonDisabled) {
			event.preventDefault();
			event.stopPropagation();
			this.submitForm();
		}
	};

	submitForm = (): void => {
		const { remindPasswordEmailValue } = this.state;
		const containsIncorrectSign = utils.validateInputChars(remindPasswordEmailValue);
		const isEmailIncorrect = utils.validateEmail(remindPasswordEmailValue);

		if (containsIncorrectSign || isEmailIncorrect) {
			return this.setState({ remindPasswordEmailError: true });
		}

		this.sendButtonDisabledFunction();
		this.setState({ remindPasswordEmailError: false });
		this.props.forgotPassword(remindPasswordEmailValue);
	};

	onResize = (): void => {
		if (window.innerWidth < 800) {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: true }));
		} else {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: false }));
		}
	};

	componentDidMount() {
		const {
			resettingPasswordFailed,
			resettingPasswordSucceed,
			closeSavePasswordNotification,
			resetPasswordTimeoutFailed,
		} = this.props;
		window.addEventListener('resize', this.onResize);
		window.addEventListener('keydown', this.onKeyDown);
		this.remindPasswordEmailRef.current.addEventListener('focusout', this.onRemindPasswordEmailFocusOut);
		this.onResize();
		this.setState({ isLoaderRender: false });
		this.closeSavePasswordNotificationTimeout = setTimeout(() => {
			if (resettingPasswordFailed || resettingPasswordSucceed || resetPasswordTimeoutFailed) {
				return closeSavePasswordNotification();
			}
		});
	}

	componentDidUpdate() {
		const {
			resettingPasswordFailed,
			resettingPasswordSucceed,
			resetPasswordTimeoutFailed,
			closeSavePasswordNotification,
		} = this.props;
		const { sendButtonDisabled } = this.state;
		if (resettingPasswordFailed && sendButtonDisabled) {
			this.sendButtonTimer = setTimeout(this.sendButtonEnabledFunction, 6000);
			this.closeNotificationTimer = setTimeout(closeSavePasswordNotification, 6000);
		}
		if (resettingPasswordSucceed && sendButtonDisabled) {
			this.sendButtonTimer = setTimeout(this.sendButtonEnabledFunction, 6000);
			this.closeNotificationTimer = setTimeout(closeSavePasswordNotification, 6000);
			this.redirectTimer = setTimeout(this.redirectToLoginPage, 6000);
		}
		if (resetPasswordTimeoutFailed && sendButtonDisabled) {
			this.sendButtonTimer = setTimeout(this.sendButtonEnabledFunction, 6000);
			this.closeNotificationTimer = setTimeout(closeSavePasswordNotification, 6000);
			this.redirectTimer = setTimeout(this.redirectToLoginPage, 6000);
		}
	}

	componentWillUnmount() {
		clearTimeout(this.sendButtonTimer);
		clearTimeout(this.redirectTimer);
		clearTimeout(this.closeSavePasswordNotificationTimeout);
		clearTimeout(this.closeNotificationTimer);
		window.removeEventListener('resize', this.onResize);
		window.removeEventListener('keydown', this.onKeyDown);
	}

	sendButtonDisabledFunction = (): void => {
		this.setState({ sendButtonDisabled: true });
	};

	sendButtonEnabledFunction = (): void => {
		this.setState({ sendButtonDisabled: false });
	};

	redirectToLoginPage = (): void => {
		this.setState({ goToLoginPage: true });
	};

	onRemindPasswordEmailFocusOut = (e): void => {
		this.setState({ remindPasswordEmailFocusOut: true });
		this.onInputChange(e);
	};

	onInputChange = (e): void => {
		const { remindPasswordEmailFocusOut } = this.state;
		const currentValue = e.target.value;
		const containsIncorrectSign = utils.validateInputChars(currentValue);
		const isEmailIncorrect = utils.validateEmail(currentValue);
		const error = containsIncorrectSign || isEmailIncorrect;

		this.setState({ remindPasswordEmailValue: currentValue, remindPasswordEmailError: containsIncorrectSign });

		if (remindPasswordEmailFocusOut) {
			this.setState({ remindPasswordEmailError: error });
		}
	};

	renderMobileNotifications = (): JSX.Element => {
		const { resettingPasswordFailed, resettingPasswordSucceed, resetPasswordTimeoutFailed } = this.props;
		const { mobileViewLocal } = this.state;
		const headerStyle = utils.getHeaderStyle(resettingPasswordFailed || resetPasswordTimeoutFailed);

		if (mobileViewLocal) {
			if (resettingPasswordFailed || resettingPasswordSucceed || resetPasswordTimeoutFailed) {
				return (
					<h5
						className={
							resettingPasswordFailed || resetPasswordTimeoutFailed
								? 'notification-open-remind-password-page-fail'
								: 'notification-open-remind-password-page-success'
						}
						style={headerStyle}
					>
						{resettingPasswordFailed
							? 'Email not found'
							: resetPasswordTimeoutFailed
							? 'E-mail to change your password was sent recently. Try again in 30 seconds.'
							: 'Reset password succeeded'}
					</h5>
				);
			}
			return <div style={emptyHeaderStyle}></div>;
		}
	};

	render() {
		const {
			classes,
			resettingPasswordFailed,
			resettingPasswordSucceed,
			closeSavePasswordNotification,
			resetPasswordTimeoutFailed,
		} = this.props;
		const { sendButtonDisabled, remindPasswordEmailError, remindPasswordEmailValue, mobileViewLocal, goToLoginPage } = this.state;
		const gridStyleEmail = { marginBottom: '10px' };

		if (goToLoginPage) {
			return <Redirect from='/pages/remind-password' to='/pages/login-page' />;
		} else {
			return (
				<div className={`${classes.container} remind-password-page`}>
					<GridContainer justify='center' direction='column' alignItems='center' justifycontentcenter='true'>
						<GridItem xs={10}>
							<img className='wisene-logo' src={Logo} alt='wisene logo'></img>
						</GridItem>
						<GridItem md={8} lg={6}>
							<Card login className={classes[this.props.cardAnimation]}>
								<form>
									<CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color='danger'>
										<h4 className={`${classes.cardTitle} remind-password-page-card-header`}>Remind password</h4>
									</CardHeader>
									<CardBody>
										<TextField
											label='Email'
											id='remindPasswordEmail'
											error={remindPasswordEmailError}
											helperText={'Incorrect email'}
											className={remindPasswordEmailError ? 'showAnimation' : ''}
											fullWidth
											required
											disabled={sendButtonDisabled}
											style={gridStyleEmail}
											inputProps={{ maxLength: utils.defaultMaxEmailLength, autoCapitalize: 'off' }}
											InputProps={{
												type: 'email',
												value: remindPasswordEmailValue,
												onChange: (e) => this.onInputChange(e),
												ref: this.remindPasswordEmailRef,
												endAdornment: (
													<InputAdornment position='end'>
														<Email className={classes.inputAdornmentIcon} />
													</InputAdornment>
												),
											}}
										/>
										<GridItem xs={12} style={{ padding: '0' }}>
											{this.renderMobileNotifications()}
										</GridItem>
										{sendButtonDisabled ? (
											<div style={loaderStyle}>
												<Loading transform={0.55} color='red' />
											</div>
										) : (
											<GridItem xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
												<Button
													id='sendPasswordButton'
													color='danger'
													onClick={this.submitForm}
													simple
													size='lg'
													disabled={sendButtonDisabled || remindPasswordEmailError || !remindPasswordEmailValue}
												>
													Send
												</Button>
											</GridItem>
										)}
									</CardBody>
									<CardFooter className={classes.justifyContentCenter}>
										<GridItem xs={12} style={{ textAlign: 'center' }}>
											<NavLink id='backButton' to='/pages/login-page'>
												Back
											</NavLink>
										</GridItem>
									</CardFooter>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
					{!mobileViewLocal ? (
						<Snackbar
							close={undefined}
							closeNotification={() => closeSavePasswordNotification()}
							color={
								resettingPasswordFailed || resetPasswordTimeoutFailed ? 'danger' : resettingPasswordSucceed ? 'success' : null
							}
							message={
								resettingPasswordFailed
									? 'Email not found. Please, check if your email is correct or try again later.'
									: resettingPasswordSucceed
									? 'Reset password link has been sent. Link will be valid for 48 hours. If you do not receive an email within 1 hour, please try again.'
									: resetPasswordTimeoutFailed
									? 'E-mail to change your password was sent recently. Try again in 30 seconds.'
									: ''
							}
							open={resettingPasswordFailed || resetPasswordTimeoutFailed || resettingPasswordSucceed}
							place='tc'
						/>
					) : null}
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		cardAnimation: state.login.cardAnimation,
		resettingPasswordSucceed: state.login.resettingPasswordSucceed,
		resettingPasswordFailed: state.login.resettingPasswordFailed,
		resetPasswordTimeoutFailed: state.login.resetPasswordTimeoutFailed,
	};
};

const actions = { forgotPassword, closeSavePasswordNotification };

const remindPasswordWithStyles = remindPasswordPageStyle(RemindPasswordPage);
export default connect(mapStateToProps, actions)(remindPasswordWithStyles);
